module.exports = __webpack_public_path__ + "img/painting_en.eb98cb8.jpg";